import { SWRFetcher } from '@commenda/utils';
import { useMemo } from 'react';
import useSWR from 'swr';
import { ITnaCustomerRow, ITnaCustomersResponse } from './types';

const LIST_PATH = 'compliance/tna-customers';

export function useTnaCustomers(enabled = true) {
  const cacheKey = enabled ? LIST_PATH : null;

  const { data, error, mutate, isLoading, isValidating } =
    useSWR<ITnaCustomersResponse>(
      cacheKey,
      cacheKey ? () => SWRFetcher({ method: 'GET' }, undefined)(LIST_PATH) : null
    );

  const rows = useMemo<ITnaCustomerRow[]>(() => data?.rows ?? [], [data]);

  return {
    rows,
    count: data?.count ?? 0,
    truncated: data?.truncated ?? false,
    error,
    mutate,
    isLoading: !!isLoading,
    isValidating: !!isValidating,
  };
}
